import type { SentryClient } from "@app/services/sentry-facade";
import type { NapiDepartureCart } from "@app/types/napi-departures-types";
import type { NapiV2CartSegment } from "@app/types/napi-v2-cart-types";

export function isSeatSelectionAvailable(
  departure_or_segment:
    | Pick<NapiDepartureCart, "vehicle">
    | Pick<NapiV2CartSegment, "vehicle">,
  sentry: SentryClient | null = null
): boolean {
  if (!(departure_or_segment && departure_or_segment.vehicle)) {
    return false;
  }

  // TODO-CART-V2: remove legacy floors check after complete migration to Cart V2
  const has_legacy_floors =
    // @ts-expect-error floor does not exist on type NapiV2CartSegment
    departure_or_segment.vehicle.floors &&
    // @ts-expect-error floor does not exist on type NapiV2CartSegment
    departure_or_segment.vehicle.floors.length > 0;

  const has_layout =
    departure_or_segment.vehicle.layout &&
    departure_or_segment.vehicle.layout.length > 0;

  if (!(has_legacy_floors || has_layout)) {
    return false;
  }

  const layout: unknown[] = has_legacy_floors
    ? // @ts-expect-error floor does not exist on type NapiV2CartSegment
      departure_or_segment.vehicle.floors
    : departure_or_segment.vehicle.layout;

  const all_floors_present = layout.every(floor => !!floor);

  if (!all_floors_present && sentry) {
    sentry.captureException(
      new Error(
        `departure.vehicle contains malformed data (hint: floors include falsy values): ${JSON.stringify(
          departure_or_segment.vehicle
        )}`
      ),
      {
        tags: {
          page: "checkout",
          component: "Bus",
          request: "isSeatSelectionAvailable"
        }
      }
    );

    return false;
  }

  return true;
}
